export const onselectChangeurl = { // eslint-disable-line
  bind: (el) => {
    const select = el;

    select.addEventListener('change', (event) => {
      window.location.assign(event.target.value);
    });
  }
};
